export default __webpack_public_path__ + "static/media/typing.a8ac6a50.mp3";